import uuid from 'node-uuid'
import moment from 'moment'
import {apiUrl, apiOption, apiResponse, errorResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'
import i18n from './i18n'

const NAMESPACE = 'Claim'
export const LINKS_LOADED = NAMESPACE + '/LinksLoaded'
export const TICKET_CLAIM_LOADED = NAMESPACE + '/TicketClaimLoaded'
export const TICKET_CLAIM_CREATED = NAMESPACE + '/TicketClaimCreated'
export const TICKET_CLAIM_STREAM_LOADED = NAMESPACE + '/TicketClaimStreamLoaded'
export const TICKET_CLAIM_STREAM_QUERIED = NAMESPACE + '/TicketClaimStreamQueried'
export const OPEN_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/OpenTicketClaimCmdSent'
export const QUALIFY_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/QualifyTicketClaimCmdSent'
export const ANSWER_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/AnswerTicketClaimCmdSent'
export const CHALLENGE_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/ChallengeTicketClaimCmdSent'
export const ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT = NAMESPACE + '/AnswerChallengeTicketClaimCmdSent'
// form actions
export const OPEN_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/OpenTicketClaimCmdUpdated'
export const QUALIFY_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/QualifyTicketClaimCmdUpdated'
export const ANSWER_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/AnswerTicketClaimCmdUpdated'
export const CHALLENGE_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/ChallengeTicketClaimCmdUpdated'
export const ANSWER_CHALLENGE_TICKET_CLAIM_CMD_UPDATED = NAMESPACE + '/AnswerChallengeTicketClaimCmdUpdated'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_TICKET_CLAIM_QUERY = {
    ...DEFAULT_QUERY
}

export function loadLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/ticketclaims', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: LINKS_LOADED,
            _links: json._links
        }
    }), LINKS_LOADED)
}

export function queryTicketClaimStream(claimQuery) {
    return loadTicketClaimStream(claimQuery, TICKET_CLAIM_STREAM_QUERIED)
}

export function loadTicketClaimStream(claimQuery, action) {
    return loading((state) => {
        const {query} = state.claim

        claimQuery = {
            ...DEFAULT_TICKET_CLAIM_QUERY,
            ...query,
            ...claimQuery
        }

        return fetch(apiUrl(config.api.url + '/ticketclaims', claimQuery), apiOption())
        .then(apiResponse)
        .then(({json, headers}) => {
            return {
                type: action || TICKET_CLAIM_STREAM_LOADED,
                range: headers.contentRange,
                stream: json.result,
                _links: json._links,
                query: claimQuery,
            }
        })
    }, action || TICKET_CLAIM_STREAM_LOADED)
}

export function loadTicketClaim(id) {
    return loading((state) => {
        const {ticketClaim} = state.claim
        id = id || ticketClaim.uid

        return fetch(apiUrl(config.api.url + '/ticketclaims/' + id), apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: TICKET_CLAIM_LOADED,
                ticketClaim: json
            }
        })
    }, TICKET_CLAIM_LOADED)
}

export function sendOpenTicketClaimCmd() {
    return loading((state) => {
        const {openTicketClaimCmd} = state.claim
        const {externalClientName, externalPatrimonyReference, externalCallDate, description, ...cmd} = openTicketClaimCmd

        const fullDescription = [
            externalClientName && (i18n.externalClientName + ' : ' + externalClientName + '. '),
            externalPatrimonyReference && (i18n.externalPatrimonyReference + ' : ' + externalPatrimonyReference + '. '),
            externalCallDate && (i18n.externalCallDate + ' : ' + moment(externalCallDate).format(i18n.dateTimeFormat.default) + '. '),
            description + '.'
        ].filter((t) => t).join('\r\n')

        const option = {
            body: {
                processUid: uuid.v4(),
                description: fullDescription,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/ticketclaims', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: OPEN_TICKET_CLAIM_CMD_SENT,
                events: json.events
            }
        })
    }, OPEN_TICKET_CLAIM_CMD_SENT)
}

export function sendQualifyTicketClaimCmd() {
    return loading((state) => {
        const {ticketClaim, qualifyTicketClaimCmd} = state.claim

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'QualifyTicketClaim',
                ...qualifyTicketClaimCmd
            }
        }

        return fetch(config.api.event.url + '/ticketclaims/' + ticketClaim.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: QUALIFY_TICKET_CLAIM_CMD_SENT
            }
        })
    }, QUALIFY_TICKET_CLAIM_CMD_SENT)
}

export function sendAnswerTicketClaimCmd() {
    return loading((state) => {
        const {ticketClaim, answerTicketClaimCmd} = state.claim

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AnswerTicketClaim',
                ...answerTicketClaimCmd
            }
        }

        return fetch(config.api.event.url + '/ticketclaims/' + ticketClaim.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ANSWER_TICKET_CLAIM_CMD_SENT
            }
        })
    }, ANSWER_TICKET_CLAIM_CMD_SENT)
}

export function sendChallengeTicketClaimCmd() {
    return loading((state) => {
        const {ticketClaim, challengeTicketClaimCmd} = state.claim

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'ChallengeTicketClaim',
                ...challengeTicketClaimCmd
            }
        }

        return fetch(config.api.event.url + '/ticketclaims/' + ticketClaim.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: CHALLENGE_TICKET_CLAIM_CMD_SENT
            }
        })
    }, CHALLENGE_TICKET_CLAIM_CMD_SENT)
}

export function sendAnswerChallengeTicketClaimCmd() {
    return loading((state) => {
        const {ticketClaim, answerChallengeTicketClaimCmd} = state.claim

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AnswerChallengeTicketClaim',
                ...answerChallengeTicketClaimCmd
            }
        }

        return fetch(config.api.event.url + '/ticketclaims/' + ticketClaim.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT
            }
        })
    }, ANSWER_CHALLENGE_TICKET_CLAIM_CMD_SENT)
}

export function createTicketClaim(ticketClaim) {
    return {
        type: TICKET_CLAIM_CREATED,
        ticketClaim: {
            _links: [],
            ...ticketClaim
        }
    }
}

export function updateOpenTicketClaimCmd(cmd) {
    return {
        type: OPEN_TICKET_CLAIM_CMD_UPDATED,
        cmd: cmd
    }
}


// WEBPACK FOOTER //
// ./lib/claim/actions.js